import Slides from './Slides.js';

import img1 from './images/portfolio/commercial-photography/005.jpg';
import img2 from './images/portfolio/commercial-photography/007.jpg';
import img3 from './images/portfolio/commercial-photography/0079.jpg';
import img4 from './images/portfolio/commercial-photography/181.jpg';
import img5 from './images/portfolio/commercial-photography/293.jpg';
import img6 from './images/portfolio/commercial-photography/437.jpg';
import img7 from './images/portfolio/commercial-photography/Bedford_0067.jpg';
import img8 from './images/portfolio/commercial-photography/Group_final_25.jpg';
import img9 from './images/portfolio/commercial-photography/IMG_007.jpg';
import img10 from './images/portfolio/commercial-photography/IMG_015a.jpg';
import img11 from './images/portfolio/commercial-photography/Img0010_fin.jpg';
import img12 from './images/portfolio/commercial-photography/Img0023.jpg';
import img13 from './images/portfolio/commercial-photography/Img0040.jpg';
import img14 from './images/portfolio/commercial-photography/Johnson_n_Johnson_2004.jpg';
import img15 from './images/portfolio/commercial-photography/Mansion.jpg';
import img16 from './images/portfolio/commercial-photography/_IMG2097.jpg';

const images = [ 
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
];

function CommercialPhotograpahy() {
    return <Slides images={images}/>;
}

export default CommercialPhotograpahy;
